import { Heading_default } from "./chunk-EXW7ZGG6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Panel/Panel.Header.tsx
import React from "react";
import clsx from "clsx";
var PanelHeader = _a => {
  var _b = _a,
    {
      title,
      secondaryAction,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["title", "secondaryAction", "children", "className"]);
  return /* @__PURE__ */React.createElement("header", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd-panel__header", className)
  }), /* @__PURE__ */React.createElement(Heading_default, {
    as: "span",
    variant: "display",
    size: "3",
    className: "pd-panel__title"
  }, title), /* @__PURE__ */React.createElement("div", {
    className: "pd-grow"
  }, children), /* @__PURE__ */React.createElement("div", {
    className: "pd-flex"
  }, secondaryAction));
};
var Panel_Header_default = PanelHeader;
export { Panel_Header_default };